"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get deviations () {
        return deviations;
    },
    get deviationsByType () {
        return deviationsByType;
    }
});
const _images = require("./images");
const _literature = require("./literature");
const _edgeCases = require("./edgeCases");
const _journals = require("./journals");
const _film = require("./film");
const _flash = require("./flash");
const _pdf = require("./pdf");
const _pixel = require("./pixel");
const _turtles = require("./turtles");
const _statuses = require("./statuses");
const _polls = require("./polls");
const _commissions = require("./commissions");
const _daily = require("./daily");
const _tiers = require("./tiers");
const deviations = _edgeCases.edgeCaseDeviations.concat(_images.imageDeviations, _pixel.pixelDeviations, _literature.literatureDeviations, _journals.journals, _film.filmDeviations, _flash.flashDeviations, _pdf.pdfDeviations, _daily.dailyDeviations, _tiers.tierDeviations);
const deviationsByType = {
    image: _images.imageDeviations,
    gif: _images.imageDeviations.filter((d)=>d.isGif),
    pixel: _pixel.pixelDeviations,
    literature: _literature.literatureDeviations,
    film: _film.filmDeviations,
    flash: _flash.flashDeviations,
    journal: _journals.journals,
    pdf: _pdf.pdfDeviations,
    statuses: [
        ..._statuses.statuses,
        ..._statuses.statusDeviationsLegacy,
        ..._statuses.statusDeviationsLong,
        ..._statuses.statusDeviationsShort,
        ..._statuses.statusDeviationsImageOnly
    ],
    polls: _polls.pollDeviations,
    commissions: _commissions.commissionDeviations,
    daily: _daily.dailyDeviations,
    edgeCases: _edgeCases.edgeCaseDeviations,
    turtles: _turtles.turtleDeviations,
    tiers: _tiers.tierDeviations
};
